export default "__VITE_ASSET__CAA$q_nL__"